export default "__VITE_ASSET__CLNBEw7a__"